import Button from '../../../../UI/Button/Button'
import { Save as SaveFunction } from '../../../../hooks/useLoadSurvey'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { useEffect, useState } from 'react'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

type Props = {
  save: SaveFunction
  hasUnsavedChanges: boolean
}

enum Status {
  NONE,
  SAVED,
  ERROR,
  UNSAVED,
}

const Save: React.FC<Props> = ({ save, hasUnsavedChanges }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [status, setStatus] = useState<Status>(Status.NONE)

  const updateStatus = (status: Status) => {
    setStatus(status)
    if (status !== Status.UNSAVED) {
      setTimeout(() => {
        setStatus(Status.NONE)
      }, 2000)
    }
  }

  useEffect(() => {
    if (status !== Status.SAVED && status !== Status.ERROR) {
      if (hasUnsavedChanges) {
        updateStatus(Status.UNSAVED)
      } else {
        updateStatus(Status.NONE)
      }
    }
  }, [hasUnsavedChanges, status])

  const saveSurvey = async () => {
    const saved = await save()
    if (saved) {
      updateStatus(Status.SAVED)
    } else {
      updateStatus(Status.ERROR)
    }
  }

  return (
    <div>
      {status !== Status.NONE && (
        <div className="flex justify-center mb-2 items-center gap-1">
          {status === Status.SAVED && (
            <>
              <CheckIcon className="w-6 fill-white" />
              <div className="text-white uppercase">{t.survey.configuration.saved}</div>
            </>
          )}
          {status === Status.ERROR && (
            <>
              <XMarkIcon className="w-6 fill-red" />
              <div className="text-red uppercase">{t.survey.configuration.error}</div>
            </>
          )}
          {status === Status.UNSAVED && (
            <>
              <ExclamationTriangleIcon className="w-6 fill-neonYellow" />
              <div className="text-neonYellow uppercase">{t.survey.configuration.unsaved}</div>
            </>
          )}
        </div>
      )}
      <Button className="font-bold text-lg w-full" contrast onClick={saveSurvey} text={t.survey.configuration.save} />
    </div>
  )
}

export default Save
